import { z } from "zod"

import { fieldOrdinaryMediaRoleV1Schema } from "./field-media-v4.js"
import { entityIdSchema } from "./identifiers.js"

export const fieldOrdinaryMediaRemoveV1Schema = z.object({
  mediaId: entityIdSchema,
  visitId: entityIdSchema,
  visitVersion: z.number().int().positive(),
  role: fieldOrdinaryMediaRoleV1Schema,
  capturedAt: z.iso.datetime({ offset: true }),
}).strict()

export type FieldOrdinaryMediaRemoveV1 = z.infer<typeof fieldOrdinaryMediaRemoveV1Schema>
